<template>
    <div>
        <div class="copyright_area">
            <div class="container">
                <div class="row align-items-center">
                    <div class="co-lg-4 col-md-4 col-sm-12 col-12 d-flex">
                        <div class="copyright_left">
                            <p>Copyright © {{ new Date().getFullYear() }} {{ $t('messages.all_rights') }}</p>
                        </div>
                    </div>
                    <div class="co-lg-4 col-md-4 col-sm-12 col-12 d-flex justify-content-center">
                        <a href="https://www.instagram.com/lobitogalapagos/" target="_blank"><i class="fab fa-instagram" style="color:#09B6AC; font-size:18px; margin-right:8px;"></i></a>
                        <a href="https://www.facebook.com/LobitoEcu/" target="_blank"><i class="fab fa-facebook" style="color:#09B6AC; font-size:18px; margin-right:8px;"></i></a>
                        <a href="https://api.whatsapp.com/send?phone=593967549023&text=Hello%20*Lobito*!%20I%20would%20like%20more%20information%20about..." target="_blank"><i class="fab fa-whatsapp" style="color:#09B6AC; font-size:18px; margin-right:5px;"></i></a>
                    </div>
                    <div class="co-lg-4 col-md-4 col-sm-12 col-12">
                        <div class="copyright_right">
                            <img src="@/assets/img/payment/mastercard-card.png" alt="mastercard card" height="36" class="creditcard-image">
                            <img src="@/assets/img/payment/visa-card.jpg" alt="visa card" height="36" width="50" class="creditcard-image">
                            <!-- <img src="@/assets/img/payment/american-card.png" alt="american express card" height="36" class="creditcard-image"> -->
                            <!-- <img src="@/assets/img/payment/diners-card.png" alt="diners club card" height="36" width="100" class="creditcard-image"> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'Footer'
}
</script>

<style>
    .email-link {
        display: inline-block; /* Ensures the element respects width */
        max-width: 100%; /* Set a desired width */
        white-space: nowrap; /* Prevent text wrapping */
        overflow: hidden; /* Hide overflow text */
        text-overflow: ellipsis; /* Add ellipsis for overflowing text */
        vertical-align: middle; /* Optional: aligns text nicely */
    }

    .creditcard-image{
        height: 36px!important;
        margin-right: 7px;
    }
</style>
